/* Native dialog; direct image link remains available without JS/dialog support.
   Keep the open dialog outside product sections which apps may replace. */
(() => {
  if (customElements.get('sleefs-size-chart')) return;
  customElements.define('sleefs-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const trigger = this.querySelector('[data-size-chart-open]');
      const dialog = this.querySelector('dialog');
      const image = this.querySelector('[data-chart-src]');
      if (!trigger || !dialog || !image || typeof dialog.showModal !== 'function') return;
      this.initialized = true;
      this.chartDialog = dialog;
      const loading = this.querySelector('[data-chart-loading]');
      const errorMessage = this.querySelector('.cro-size-chart-error');
      const productId = this.dataset.chartProduct;
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) return;
        // Moving before showModal prevents a product rerender from dismissing it.
        document.body.append(dialog);
        if (!image.hasAttribute('src')) image.src = image.dataset.chartSrc;
        dialog.showModal();
        document.documentElement.classList.add('cro-size-chart-open');
      });
      image.addEventListener('load', () => {
        if (loading) loading.hidden = true;
      });
      image.addEventListener('error', () => {
        if (loading) loading.hidden = true;
        image.hidden = true;
        if (errorMessage) errorMessage.hidden = false;
      });
      dialog.querySelector('[data-size-chart-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (this.isConnected) this.append(dialog);
        else dialog.remove();
        if (!document.querySelector('.cro-size-chart-dialog[open]')) document.documentElement.classList.remove('cro-size-chart-open');
        const replacement = Array.from(document.querySelectorAll('sleefs-size-chart'))
          .find(element => element.dataset.chartProduct === productId && element.getClientRects().length);
        const focusTarget = trigger.isConnected ? trigger : replacement?.querySelector('[data-size-chart-open]');
        focusTarget?.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      // An open dialog survives its source component until the user dismisses it.
      if (this.chartDialog && !this.chartDialog.open) this.chartDialog.remove();
      if (!document.querySelector('.cro-size-chart-dialog[open]')) document.documentElement.classList.remove('cro-size-chart-open');
    }
  });
})();
